import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToken } from "../context/TokenContext";
import { supabase } from "../supabaseClient";
import YildizArkaplan from "../components/YildizArkaplan";
import { useTranslation } from "react-i18next";

const AVATARLAR = ['🔮', '🌙', '⭐', '🌸', '🦋', '🐉', '👁️', '✨'];

export default function Profil() {
  const navigate = useNavigate();
  const { tokenBalance, user } = useToken();
  const { t } = useTranslation();

  const [yasalAcik, setYasalAcik] = useState(false);
  const [avatarModal, setAvatarModal] = useState(false);
  const [avatarId, setAvatarId] = useState(1);
  const [ad, setAd] = useState("");
  const [cinsiyet, setCinsiyet] = useState("");
  const [kayitYukleniyor, setKayitYukleniyor] = useState(false);
  const [toast, setToast] = useState(false);

  useEffect(() => {
    if (!user) return;
    const loadProfile = async () => {
      const { data } = await supabase
        .from('profiles')
        .select('ad, cinsiyet, avatar_id')
        .eq('id', user.id)
        .single();
      if (data) {
        setAvatarId(data.avatar_id || 1);
        setAd(data.ad || "");
        setCinsiyet(data.cinsiyet || "");
      }
    };
    loadProfile();
  }, [user]);

  const avatarDegistir = async (idx) => {
    const yeniId = idx + 1;
    setAvatarId(yeniId);
    setAvatarModal(false);
    if (user) {
      await supabase.from('profiles').update({ avatar_id: yeniId }).eq('id', user.id);
    }
  };

  const kaydet = async () => {
    if (!user) return;
    setKayitYukleniyor(true);
    await supabase
      .from('profiles')
      .update({ ad: ad.trim() || null, cinsiyet: cinsiyet || null })
      .eq('id', user.id);
    setKayitYukleniyor(false);
    setToast(true);
    setTimeout(() => setToast(false), 2000);
  };

  const handleCikis = async () => {
    localStorage.removeItem('remil_gorev_state');
    await supabase.auth.signOut();
    navigate("/giris");
  };

  const aktifAvatar = AVATARLAR[(avatarId - 1) % AVATARLAR.length];
  const kullaniciAdi = ad || user?.user_metadata?.display_name || user?.email?.split("@")[0] || t("profile.guest");

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)",
      position: "relative",
      fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420,
      margin: "0 auto",
    }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
        .profil-input:focus { border-color: rgba(168,85,247,0.5) !important; }
      `}</style>

      <YildizArkaplan />

      {/* Avatar Modal */}
      {avatarModal && (
        <div
          onClick={() => setAvatarModal(false)}
          style={{
            position: "fixed", inset: 0, zIndex: 100,
            background: "rgba(0,0,0,0.75)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "linear-gradient(135deg, #1a0d2e, #110d24)",
              border: "1px solid rgba(168,85,247,0.3)",
              borderRadius: 20, padding: "24px",
              width: 280, textAlign: "center",
            }}
          >
            <div style={{ fontSize: 13, fontWeight: 700, color: "rgba(200,170,255,0.8)", marginBottom: 16, letterSpacing: 1, textTransform: "uppercase" }}>
              Avatar Seç
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10 }}>
              {AVATARLAR.map((emoji, idx) => (
                <button
                  key={idx}
                  onClick={() => avatarDegistir(idx)}
                  style={{
                    fontSize: 30, background: avatarId === idx + 1 ? "rgba(168,85,247,0.3)" : "rgba(255,255,255,0.05)",
                    border: avatarId === idx + 1 ? "2px solid rgba(168,85,247,0.7)" : "1px solid rgba(255,255,255,0.1)",
                    borderRadius: 14, padding: "12px 0", cursor: "pointer",
                    transition: "all 0.15s",
                  }}
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {toast && (
        <div style={{
          position: "fixed", top: 28, left: "50%", transform: "translateX(-50%)",
          zIndex: 200, background: "rgba(74,222,128,0.15)",
          border: "1px solid rgba(74,222,128,0.4)",
          borderRadius: 12, padding: "10px 22px",
          fontSize: 13, color: "#4ADE80", fontWeight: 700,
          whiteSpace: "nowrap", boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
        }}>
          Bilgiler güncellendi ✓
        </div>
      )}

      <div style={{ position: "relative", zIndex: 1, paddingBottom: 90 }}>

        {/* Header */}
        <div style={{ padding: "26px 24px 16px" }}>
          <div style={{ fontSize: 26, fontWeight: 800, color: "#fff", fontFamily: "Georgia, serif" }}>
            {t("profile.title")}
          </div>
          <div style={{ fontSize: 13, color: "rgba(200,170,255,0.6)", marginTop: 4 }}>
            {t("profile.subtitle")}
          </div>
        </div>

        {/* Avatar & Kullanıcı */}
        <div style={{
          padding: "0 24px 20px",
          display: "flex", flexDirection: "row",
          alignItems: "center", gap: 16,
        }}>
          {/* Avatar */}
          <div
            onClick={() => user && setAvatarModal(true)}
            style={{
              width: 80, height: 80, borderRadius: "50%",
              background: "rgba(168,85,247,0.2)",
              border: "2px solid rgba(168,85,247,0.5)",
              display: "flex", alignItems: "center",
              justifyContent: "center", fontSize: 40,
              cursor: user ? "pointer" : "default",
              position: "relative", flexShrink: 0,
            }}
          >
            {aktifAvatar}
            {user && (
              <div style={{
                position: "absolute", bottom: 0, right: 0,
                background: "rgba(124,58,237,0.9)", borderRadius: "50%",
                width: 22, height: 22, display: "flex", alignItems: "center",
                justifyContent: "center", fontSize: 10, border: "2px solid #110d24",
              }}>
                ✏️
              </div>
            )}
          </div>

          {/* Sağ: isim + badge + token */}
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 20, fontWeight: 700, color: "#fff", fontFamily: "Georgia, serif" }}>
              {user ? kullaniciAdi : t("profile.guest")}
            </div>
            {user ? (
              <>
                <div style={{
                  marginTop: 6, fontSize: 11,
                  color: "rgba(168,85,247,0.7)",
                  background: "rgba(168,85,247,0.1)",
                  border: "1px solid rgba(168,85,247,0.2)",
                  borderRadius: 20, padding: "3px 10px",
                  display: "inline-block",
                }}>
                  ✦ {t("profile.member")}
                </div>
                <div
                  onClick={() => navigate("/token-kazan")}
                  style={{
                    marginTop: 8, fontSize: 18, color: "#F9CB42", fontWeight: 800,
                    cursor: "pointer", display: "flex", alignItems: "center", gap: 5,
                  }}
                >
                  <span>🪙</span>
                  <span>{tokenBalance} Token</span>
                </div>
              </>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 12 }}>
                <button onClick={() => navigate("/giris")} style={{
                  padding: "12px 28px", borderRadius: 12,
                  background: "linear-gradient(135deg, #7c3aed, #a855f7)",
                  border: "none", color: "#fff", fontSize: 14,
                  fontWeight: 700, cursor: "pointer",
                  boxShadow: "0 0 20px rgba(168,85,247,0.4)",
                }}>
                  {t("profile.registerBtn")}
                </button>
                <button onClick={() => navigate("/giris")} style={{
                  padding: "10px 28px", borderRadius: 12,
                  background: "rgba(255,255,255,0.07)",
                  border: "1px solid rgba(255,255,255,0.15)",
                  color: "rgba(255,255,255,0.6)", fontSize: 13,
                  fontWeight: 600, cursor: "pointer",
                }}>
                  {t("profile.loginBtn")}
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Kullanıcı Bilgileri Formu */}
        {user && (
          <div style={{ padding: "0 24px 20px" }}>
            <div style={{
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 16, padding: "16px",
            }}>
              <div style={{
                fontSize: 11, color: "rgba(200,170,255,0.6)",
                letterSpacing: 1.5, textTransform: "uppercase",
                fontWeight: 600, marginBottom: 14,
              }}>
                Bilgilerini Güncelle
              </div>

              {/* Ad */}
              <div style={{ marginBottom: 12 }}>
                <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginBottom: 6 }}>Ad</div>
                <input
                  className="profil-input"
                  value={ad}
                  onChange={(e) => setAd(e.target.value)}
                  placeholder="Adın nedir?"
                  style={{
                    width: "100%", padding: "11px 14px", borderRadius: 10,
                    background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)",
                    color: "#fff", fontSize: 14, outline: "none",
                    fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
                    transition: "border-color 0.2s",
                  }}
                />
              </div>


              {/* Cinsiyet */}
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginBottom: 8 }}>Cinsiyet</div>
                <div style={{ display: "flex", gap: 8 }}>
                  {[
                    { val: "kadin", label: "Kadın" },
                    { val: "erkek", label: "Erkek" },
                    { val: "belirtmek_istemiyorum", label: "Belirtmek istemiyorum" },
                  ].map((opt) => (
                    <button
                      key={opt.val}
                      onClick={() => setCinsiyet(cinsiyet === opt.val ? "" : opt.val)}
                      style={{
                        flex: 1, padding: "8px 4px", borderRadius: 10,
                        fontSize: 11, fontWeight: 600, cursor: "pointer",
                        background: cinsiyet === opt.val ? "rgba(168,85,247,0.25)" : "rgba(255,255,255,0.05)",
                        border: cinsiyet === opt.val ? "1px solid rgba(168,85,247,0.5)" : "1px solid rgba(255,255,255,0.1)",
                        color: cinsiyet === opt.val ? "#C084FC" : "rgba(255,255,255,0.45)",
                        transition: "all 0.15s",
                        fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
                      }}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Kaydet */}
              <button
                onClick={kaydet}
                disabled={kayitYukleniyor}
                style={{
                  width: "100%", padding: "13px", borderRadius: 12,
                  background: kayitYukleniyor ? "rgba(168,85,247,0.2)" : "linear-gradient(135deg, #7c3aed, #a855f7)",
                  border: "none", color: "#fff", fontSize: 14, fontWeight: 700,
                  cursor: kayitYukleniyor ? "default" : "pointer",
                  fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
                }}
              >
                {kayitYukleniyor ? "Kaydediliyor..." : "Kaydet"}
              </button>
            </div>
          </div>
        )}

        {/* Menü */}
        <div style={{ padding: "0 24px" }}>
          {/* Token Kazan */}
          <div
            onClick={() => navigate("/token-kazan")}
            style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "16px", borderRadius: 14, marginBottom: 8,
              background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)",
              cursor: "pointer", transition: "all 0.2s",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.07)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.04)"; }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ fontSize: 20 }}>🎁</span>
              <div>
                <div style={{ fontSize: 14, color: "#fff", fontWeight: 600 }}>Reklam İzle</div>
                <div style={{ fontSize: 11, color: "rgba(255,255,255,0.35)", marginTop: 2 }}>50 token kazan</div>
              </div>
            </div>
            <span style={{ color: "rgba(255,255,255,0.3)", fontSize: 16 }}>›</span>
          </div>

          {/* Bildirimler */}
          <div
            style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "16px", borderRadius: 14, marginBottom: 8,
              background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)",
              cursor: "default",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ fontSize: 20 }}>🔔</span>
              <div style={{ fontSize: 14, color: "#fff", fontWeight: 600 }}>Bildirimler</div>
            </div>
            <span style={{ color: "rgba(255,255,255,0.3)", fontSize: 16 }}>›</span>
          </div>
        </div>

        {/* Yasal Metinler Accordion */}
        {(() => {
          const yasalLinks = [
            { label: "Kullanım Koşulları", tip: "kullanim" },
            { label: "Gizlilik Politikası", tip: "gizlilik" },
            { label: "Çerez Politikası", tip: "cerez" },
            { label: "Sıkça Sorulan Sorular", tip: "sss" },
            { label: "Mesafeli Satış Sözleşmesi", tip: "mesafeli" },
            { label: "İptal ve İade Koşulları", tip: "iptal" },
            { label: "Veri Silme Talebi", tip: "veri-silme" },
          ];
          return (
            <div style={{ padding: "16px 24px 0" }}>
              <div
                onClick={() => setYasalAcik(a => !a)}
                style={{
                  background: "rgba(124,58,237,0.1)",
                  border: "1px solid rgba(124,58,237,0.35)",
                  borderRadius: yasalAcik ? "14px 14px 0 0" : 14,
                  padding: "14px 18px",
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  cursor: "pointer",
                }}
              >
                <span style={{ fontSize: 14, fontWeight: 700, color: "#a78bfa" }}>📋 Yasal Metinler</span>
                <span style={{ fontSize: 14, color: "rgba(167,139,250,0.7)" }}>{yasalAcik ? "▲" : "▼"}</span>
              </div>
              {yasalAcik && (
                <div style={{ border: "1px solid rgba(124,58,237,0.35)", borderTop: "none", borderRadius: "0 0 14px 14px", overflow: "hidden" }}>
                  {yasalLinks.map((link, i) => (
                    <div
                      key={link.tip}
                      onClick={() => navigate(`/yasal/${link.tip}`)}
                      style={{
                        padding: "13px 18px",
                        display: "flex", alignItems: "center", justifyContent: "space-between",
                        background: i % 2 === 0 ? "rgba(255,255,255,0.03)" : "rgba(255,255,255,0.015)",
                        borderTop: i === 0 ? "none" : "1px solid rgba(255,255,255,0.05)",
                        cursor: "pointer",
                      }}
                      onMouseDown={(e) => { e.currentTarget.style.background = "rgba(124,58,237,0.15)"; }}
                      onMouseUp={(e) => { e.currentTarget.style.background = i % 2 === 0 ? "rgba(255,255,255,0.03)" : "rgba(255,255,255,0.015)"; }}
                      onTouchStart={(e) => { e.currentTarget.style.background = "rgba(124,58,237,0.15)"; }}
                      onTouchEnd={(e) => { e.currentTarget.style.background = i % 2 === 0 ? "rgba(255,255,255,0.03)" : "rgba(255,255,255,0.015)"; }}
                    >
                      <span style={{ fontSize: 13, color: "rgba(255,255,255,0.7)" }}>{link.label}</span>
                      <span style={{ fontSize: 16, color: "rgba(255,255,255,0.3)" }}>›</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })()}

        {/* Çıkış / Giriş */}
        <div style={{ padding: "16px 24px 0" }}>
          {user ? (
            <button
              onClick={handleCikis}
              style={{
                width: "100%", padding: "16px", borderRadius: 14,
                background: "rgba(239,68,68,0.15)",
                border: "1px solid rgba(239,68,68,0.3)",
                color: "#FCA5A5", fontSize: 15, fontWeight: 700,
                cursor: "pointer", fontFamily: "Georgia, serif",
              }}
            >
              {t("profile.signOut")}
            </button>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <button
                onClick={() => navigate("/giris")}
                style={{
                  width: "100%", padding: "18px", borderRadius: 14,
                  background: "linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #c084fc 100%)",
                  border: "none", color: "#fff", fontSize: 16,
                  fontWeight: 800, cursor: "pointer", fontFamily: "Georgia, serif",
                  boxShadow: "0 0 24px rgba(168,85,247,0.5)",
                  letterSpacing: 0.5,
                }}
              >
                {t("profile.registerBtn2")}
              </button>
              <button
                onClick={() => navigate("/giris")}
                style={{
                  width: "100%", padding: "14px", borderRadius: 14,
                  background: "rgba(255,255,255,0.08)",
                  border: "1px solid rgba(255,255,255,0.2)",
                  color: "#fff", fontSize: 14,
                  fontWeight: 600, cursor: "pointer", fontFamily: "Georgia, serif",
                }}
              >
                {t("profile.loginBtn2")}
              </button>
            </div>
          )}
        </div>

        {/* iyzico logo */}
        <div style={{ textAlign: "center", padding: "28px 0 8px", opacity: 0.4 }}>
          <img src="/logo_band_colored.svg" alt="iyzico" style={{ height: 22 }} />
        </div>

      </div>
    </div>
  );
}
